"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldJoinMatch = void 0;
/** Two joins that match each other.
 *
 * This interface does not accept CollectionModelFields because Angular uses it.
 */
class FieldJoinMatch {
    constructor(...joins) {
        this.fieldJoins = joins;
    }
    getJoin(subformInstanceID, fieldName) {
        for (const join of this.fieldJoins) {
            if (join.field.parent.instanceId === subformInstanceID && join.field.schema.id === fieldName) {
                return join;
            }
        }
        return undefined;
    }
    getOppositeJoin(subformInstanceID, fieldName) {
        const join = this.getJoin(subformInstanceID, fieldName);
        if (join == null) {
            return undefined;
        }
        return this.fieldJoins.find(fieldJoin => fieldJoin !== join);
    }
}
exports.FieldJoinMatch = FieldJoinMatch;
//# sourceMappingURL=field.join.js.map